import React, { useState } from "react";
import { useClickOutside } from "@mantine/hooks";
import { useCurrency } from "@/contexts/CurrencyContext";

const CURRENCIES = [
  { code: "NGN" as const, label: "NGN", symbol: "₦" },
  { code: "USD" as const, label: "USD", symbol: "$" },
  { code: "GBP" as const, label: "GBP", symbol: "£" },
  { code: "CAD" as const, label: "CAD", symbol: "C$" },
  { code: "EUR" as const, label: "EUR", symbol: "€" },
  { code: "CNY" as const, label: "CNY", symbol: "¥" },
];

export const CurrencySelector: React.FC = () => {
  const { selectedCurrency, setSelectedCurrency } = useCurrency();
  const [opened, setOpened] = useState(false);
  const [dropdownRef, setDropdownRef] = useState<HTMLDivElement | null>(null);
  useClickOutside(() => setOpened(false), null, [dropdownRef]);

  const current =
    CURRENCIES.find((c) => c.code === selectedCurrency) ?? CURRENCIES[0];

  return (
    <div className="relative" ref={setDropdownRef}>
      <button
        type="button"
        onClick={() => setOpened((prev) => !prev)}
        className="flex items-center gap-1 rounded-lg border border-soft-200 bg-white px-3 py-1.5 text-sm font-semibold text-blue-primary hover:bg-gray-50"
      >
        <span>{current.symbol}</span>
        <span>{current.code}</span>
        <span className="text-xs text-gray-500">▼</span>
      </button>

      {opened && (
        <div className="absolute right-0 z-50 mt-2 w-36 overflow-hidden rounded-lg border border-soft-200 bg-white shadow-lg">
          {CURRENCIES.map((currency) => (
            <button
              key={currency.code}
              type="button"
              onClick={() => {
                setSelectedCurrency(currency.code);
                setOpened(false);
              }}
              className={`flex w-full items-center gap-2 px-4 py-2 text-left text-sm hover:bg-gray-50 ${
                selectedCurrency === currency.code
                  ? "font-bold text-bnp-cyan"
                  : "text-blue-primary"
              }`}
            >
              <span>{currency.symbol}</span>
              <span>{currency.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
